// extracted by mini-css-extract-plugin
export var deleteIcon = "_jg-5";
export var deleteOption = "_jg-3";
export var divider = "_jg-2";
export var downloadIcon = "_jg-4";
export var drawer = "_jg-0";
export var drawerFooter = "_jg-6";
export var drawerOpen = "_jg-1";
export var highlighted = "_jg-7";
export var lighterHighlight = "_jg-8";